import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 引入element-ui的样式文件
import BaiduMap from 'vue-baidu-map'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/permission'
import '@/icons'
// import { post, fetch, patch, put, setResponseFilter, setRequestFilter } from '@/common/http'

// import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue

// // 手动引入 ECharts 各模块来减小打包体积
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'

import VCharts from 'v-charts'

// 如果需要配合 ECharts 扩展使用，只需要直接引入扩展包即可
// 以 ECharts-GL 为例：
// 需要安装依赖：npm install --save echarts-gl，并添加如下引用
// import 'echarts-gl'

// 注册组件后即可使用
// Vue.component('v-chart', ECharts)

// 定义全局变量
// Vue.prototype.$post = post
// Vue.prototype.$fetch = fetch
// Vue.prototype.$patch = patch
// Vue.prototype.$put = put

// Vue.use(BaiduMap, {
//   ak: 'kdLvpfGt8Q6u6yYtuIthLv8IHG6IwWel'
// })

Vue.use(BaiduMap, {
  ak: ''
})

Vue.use(ElementUI) // 通过这个命令使所有的element-ui标签(<el-*></el-*>)可被解析
Vue.use(VCharts)

Vue.config.productionTip = false

// const flag = 0

// const vue = new Vue({
//   router,
//   store,
//   render: (h) => h(App)
// }).$mount('#app')

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

// // 设置request拦截器
// setRequestFilter(vue)
// // 设置response拦截器
// setResponseFilter(vue)
